import type { AiOsRisk, AiOsVerification } from '../../../app/ai-os'
import type { CopyId } from '../../../copy'

/**
 * 那两张「展开之后那一句解释」的表。
 *
 * 与 `labels.tsx` 分开只有一个理由：那个文件里全是组件，而
 * `react-refresh/only-export-components` 对「组件文件里再导出一张表」
 * 会警告——它说的是真的，那种文件热更时会整块重挂。
 */

/** 展开之后那一句解释。第一屏不出现——技术细节放第二层。 */
export const RISK_DETAIL: Record<AiOsRisk, CopyId> = {
  green: 'ai_os.risk.green.detail',
  amber: 'ai_os.risk.amber.detail',
  red: 'ai_os.risk.red.detail',
}

export const VERIFICATION_DETAIL: Record<AiOsVerification, CopyId> = {
  candidate: 'ai_os.evidence.candidate.detail',
  preview_verified: 'ai_os.evidence.preview_verified.detail',
  production_verified: 'ai_os.evidence.production_verified.detail',
}

